export default () => ({
  info: false,
  token: null,
  error: null,
  loggingIn: false,
  gettingUserInfo: false,
  tokenCertificate: null,
});
